import { type MenuItem } from '@/shared/constants';
import { memo, useRef } from 'react';
import { SidebarMenuGroup } from './sidebar-menu-group.component';
import { SidebarMenuItem } from './sidebar-menu-item.component';
import './sidebar.styles.css';

type SidebarMenuProps = {
  items: MenuItem[];
  isExpanded: boolean;
  onMenuClick: () => void;
};

export const SidebarMenu = memo(function SidebarMenu({
  items,
  isExpanded,
  onMenuClick,
}: SidebarMenuProps) {
  const navRef = useRef<HTMLElement>(null);

  return (
    <nav ref={navRef} className='sidebar-menu flex flex-col gap-2'>
      {items.map(item =>
        item.subItems && item.subItems.length > 0 ? (
          <SidebarMenuGroup
            key={item.id}
            item={item}
            isExpanded={isExpanded}
            onMenuClick={onMenuClick}
          />
        ) : (
          <SidebarMenuItem
            key={item.id}
            item={item}
            isExpanded={isExpanded}
            onMenuClick={onMenuClick}
            permissions={item.permissions}
          />
        )
      )}
    </nav>
  );
});
